/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
// if you want to add a color, just add it in the 'color' object as a key:value pair
// dont touch anything else!!
const color = {
  grey_dark: '#3e4956',
  grey_primary: '#b6b8b9',
  grey_light: '#dedede',
  blue_dark: '#10253f',
  blue_grey: '#192d45',
  blue_primary: '#3975cb',
  blue_tag: '#cee2f3',
  blue_light: '#a0c7ff',
  medium_gray: 'gray',
  black_primary: '#000000',
  white_primary: '#ffffff',
  white_blue: '#ecf5ff',
  blue_hover: 'e6f0ff',
  green_rating: 'green',
  yellow_rating: 'yellow',
  red_rating: 'red',
  gray_special: '#555555',
  blue_lighter: '#f9fafc',
  golden_star: '#f47d02',
  
};
export default color;

export const colorStyle = {};

for (const key in color) {
  const property = `--${key}`;
  colorStyle[property] = color[key];
}
